import {Fragment} from "react";
import {useHistory} from "react-router-dom";
import SmallSpinner from "../SmallSpinner";
import {saveAs} from "file-saver";
import {useState} from "react";

function PaidInvoiceRow({invoice, selectedInvoice, setError}) {
	const history = useHistory();
	const [loading, setLoading] = useState(false);

	async function downloadInvoice() {
		if (!selectedInvoice) {
			return;
		}
		setLoading(true);
		setError('');
		try {
			const response = await fetch(process.env.REACT_APP_endPoint + '/v1/invoices/' + selectedInvoice + '/xero-pdf', {
				method: "GET",
				credentials: "include"
			});
			if (response.status === 200) {
				const blob = await response.blob();
				let filename = 'invoice-' + selectedInvoice + '-paid' + '.pdf';
				saveAs(blob, filename);
			}
			else {
				setError('Failed to download Xero invoice PDF.');
			}
		}
		catch (e) {
			console.error(e);
			setError('Failed to download Xero invoice PDF.');
		}
		finally {
			setLoading(false);
		}
	}

	return (
		<tr onClick={(evt) => {
			history.push({
				pathname: "/payments/paidInvoices",
				search: "?invoiceId=" + invoice.id
			});
		}} className={selectedInvoice === invoice.id ? "table-secondary" : ""}>
			<td>{invoice.messageCount > 0 && <i className="bi bi-star-fill text-warning" />} {invoice.fullName}</td>
			<td>{invoice.email} {invoice.isLsp && <Fragment>({invoice.companyName})</Fragment>}</td>
			<td>{invoice.invoiceDate ?? invoice.stamp}</td>
			<td>{invoice.dueDate}</td>
			<td>{invoice.paymentDate}</td>
			<td>{invoice.stripePlatform}</td>
			<td>&euro;{invoice.value.toLocaleString()}</td>
			<td className="text-center">
				{invoice.xero_invoice_id ?
					<button className="btn btn-sm btn-outline-secondary" onClick={(evt) => {
						evt.stopPropagation();
						downloadInvoice();
					}} disabled={loading}>
						{loading ? <SmallSpinner /> : <i className="bi bi-download"></i>}
					</button>
				: "--"}
			</td>
		</tr>
	);
}

export default PaidInvoiceRow;